import { useEffect, useState } from 'react'

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import css from './sass/tabnav.module.scss'
import ConfirmLeavePage from '../admin/ConfirmModal/ConfirmLeavePage'
import { setSessionItem } from './utils'

export default function TabNav( {titles, panels, goToIndex, unsavedAuction} ) {

  const [selectedIndex, setSelectedIndex] = useState(0)
  const [showModal, setShowModal] = useState(false)
  const [modalIndex, setModalIndex] = useState(null)

  useEffect(() => {
    setSelectedIndex(goToIndex)
  }, [goToIndex])

  const handleTabSelection = (index) => {

    if (selectedIndex === 0 && unsavedAuction && index !== 0) {
      setModalIndex(index)
      setShowModal(true)
    }
    else {
      setModalIndex(null)
      setSelectedIndex(index)
    }
  }

  const confirmLeave = () => {
    setSelectedIndex(modalIndex)
    setSessionItem('unsavedAuction', null)
    setShowModal(false)
  }

  return (
    <>
    {showModal && <ConfirmLeavePage setShowConfirmModal={setShowModal} confirmLeave={confirmLeave}/> }
      <Tabs className={css['react-tabs']}
          selectedIndex={selectedIndex}
          onSelect={(index) => handleTabSelection(index)}
      >
        <TabList className={css['react-tabs__tab-list']}>
          {titles && titles.map((title, idx) => <Tab 
              key={idx}
              className={css['react-tabs__tab']}
              selectedClassName={css['react-tabs__tab--selected']}
              disabledClassName={css['react-tabs__tab--disabled']}
            >{title.toUpperCase()}</Tab>)}
        </TabList>
        {panels && panels.map((panel, idx) => <TabPanel
            key={idx}
            className={css['react-tabs__tab-panel']}
            selectedClassName={css['react-tabs__tab-panel--selected']}
          >{panel}</TabPanel>)}
      </Tabs>
    </>
  )
}